/**
 * Get file name from file path
 * @param filePath - File path url
 * @returns 
 */
export const getFileNameFromPath = (filePath: string): string =>{
    try{
      if (!filePath) {
        return "";
      }
      
      const separator = filePath.includes("az") ? "/" : "\\";
      const parts = filePath.split(separator);
      return parts.length > 0 ? parts[parts.length - 1] : "";
    }
    catch(error){
      return ""
    }
  }